import React from "react";
import ReactPlayer from "react-player/lazy";

import "../../assets/css/style.css";

const VideoPlayer = ({ video, onEnded, style, onPlay }) => {
  return (
    <div className="video-wrapper" style={style}>
      <ReactPlayer
        url={video}
        playing
        controls
        className="react-video-player"
        onError={e => console.error("Error playing video:", e)}
        onEnded={() => onEnded && onEnded()}
        onPlay={() => onPlay && onPlay()}
      />
    </div>
  );
};

export default VideoPlayer;
